/*
 * Copyright (c) 2023 NEXTwfl INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTwfl INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class ValidIntervalModel extends JSONable {
  valid: boolean | null = null;
  validFrom: string | null = null;
  validTo: string | null = null;
}
